// Hero carousel — used by sections/fresh-hero.liquid.
// Supports more than one instance per page by scoping all queries to each
// [data-carousel] root instead of relying on page-wide ids.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var slidesEl = root.querySelector('[data-carousel-slides]');
    var slides = slidesEl.children;
    var slideCount = slides.length;
    if (slideCount <= 1) return;

    var dotsEl = root.querySelector('[data-carousel-dots]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var current = 0;
    var autoplayMs = 6000;
    var timer = null;

    if (dotsEl) {
      for (var i = 0; i < slideCount; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          if (index === 0) dot.classList.add('active');
          dot.addEventListener('click', function () { goTo(index); restart(); });
          dotsEl.appendChild(dot);
        })(i);
      }
    }

    function update() {
      slidesEl.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (dotsEl) {
        Array.prototype.forEach.call(dotsEl.children, function (d, i) {
          d.classList.toggle('active', i === current);
        });
      }
    }
    function goTo(i) {
      current = (i + slideCount) % slideCount;
      update();
    }
    function next() { goTo(current + 1); }

    function restart() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, autoplayMs);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); restart(); });

    var touchStartX = 0;
    slidesEl.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    slidesEl.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (diff > 40) { goTo(current - 1); restart(); }
      if (diff < -40) { goTo(current + 1); restart(); }
    });

    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);

    restart();
  });
});
